import * as actionTypes from './actionTypes';

export const fetchPortForwarding = () => ({
    type: actionTypes.FETCH_PORT_FORWARDING
})

export const setPortForwardingStartTime = (portForwardingStartedAt) => ({
    type: actionTypes.SET_PORT_FORWARDING_START_TIME,
    portForwardingStartedAt,
})

export const portForwardingSuccess = () => ({
    type: actionTypes.SET_PORT_FORWARDING_SUCCESS,
})

export const portForwardingFail = (portForwardingError) => ({
    type: actionTypes.SET_PORT_FORWARDING_FAIL,
    portForwardingError,
})
export const getDhcpReservations = () => ({
    type: actionTypes.GET_DHCP_RESERVATIONS
})

export const getDhcpReservationsLoading = () => ({
    type: actionTypes.GET_DHCP_RESERVATIONS_LOADING
})
export const getDhcpReservationsSuccess = (payload) => ({
    type: actionTypes.GET_DHCP_RESERVATIONS_SUCCESS,
    payload
})
export const getDhcpReservationsFail = () => ({
    type: actionTypes.GET_DHCP_RESERVATIONS_FAIL
})
export const setNewDHCPReservations = () => ({
    type: actionsTypes.SET_NEW_DHCP_RESERVATIONS
})
export const setNewDHCPReservationsLoading = () => ({
    type: actionTypes.SET_NEW_DHCP_RESERVATIONS_LOADING
})
export const setNewDHCPReservationsSuccess = (payload) => ({
    type: actionsTypes.SET_NEW_DHCP_RESERVATIONS_SUCCESS,
    payload
})
export const setNewDHCPReservationsFail = () => ({
    type: actionsTypes.SET_NEW_DHCP_RESERVATIONS_FAIL
})


